import React, { useState } from 'react';
import EaHeader from '@components/ea/EaHeader';
import EaPlanInfo from '@components/ea/EaPlanInfo';
import EaBottom from '@components/ea/EaBottom';
import { toSummaryName } from '@common/utils/index';

import SatModal from '@components/common/satUI/SatModal';
import SatButton from '@components/common/satUI/SatButton';

const EaPlanInfoMain = props => {
  const [isPlanViewMore, setIsPlanViewMore] = useState(false);
  const [isForiegnerPopup, setIsForiegnerPopup] = useState(false);
  const {
    planMainInfo,
    onClickNext,
    isPracticeMode = false,
    isForiegner = false,
    republishYn,
    isPartSub,
    isConstractChange,
  } = props;

  const handleForiegnerCheck = () => {
    if (isForiegner) {
      setIsForiegnerPopup(true);
    } else {
      onClickNext();
    }
  };

  return (
    <>
      <EaHeader
        title={`${toSummaryName(planMainInfo.insuredPrspInfo.name)} 
        고객님을 위한 맞춤형 ${
          !isConstractChange && isPartSub
            ? '미결 보완'
            : republishYn
            ? '청약 보완'
            : '보험 가입'
        }`}
        isFirstPage={true}
        onClickNext={onClickNext}
        isPracticeMode={isPracticeMode}
      />
      <EaPlanInfo
        planMainInfo={planMainInfo}
        mainContractInfo={planMainInfo.planEstablishProduct.filter(
          data => data.mainPolicyRiderTypeCode === 'P',
        )}
        riderContractInfo={planMainInfo.planEstablishProduct.filter(
          data => data.mainPolicyRiderTypeCode === 'R',
        )}
        isPlanViewMore={isPlanViewMore}
        setIsPlanViewMore={setIsPlanViewMore}
        isUsdPlan={planMainInfo.currencyUsdYN === 'Y'}
      />
      <EaBottom
        label={republishYn ? '청약보완 시작' : '보험가입 시작'}
        onClick={handleForiegnerCheck}
        disabled={false}
      />
      <SatModal
        visible={isForiegnerPopup}
        setVisible={() => {
          setIsForiegnerPopup(false);
        }}
        type="confirm"
        render={() => {
          return (
            <>
              <div className="cont">
                <p className="layer-text info text-center">
                  {`본인은 한국어 의사소통이 원활하여 상품설명서 내용에 대해 충분히 설명받고 이해 후 청약을 진행합니다. `}
                </p>
              </div>
              <div className="btn-group">
                <SatButton
                  styleClass="btn-half cancel"
                  label={'취소'}
                  onClick={() => setIsForiegnerPopup(false)}
                />
                <SatButton
                  styleClass="btn-half confirm"
                  label={'확인'}
                  onClick={() => onClickNext()}
                />
              </div>
            </>
          );
        }}
      />
    </>
  );
};

export default EaPlanInfoMain;
